import { render, staticRenderFns } from "./rebateSet.vue?vue&type=template&id=945ca978&scoped=true"
import script from "./rebateSet.vue?vue&type=script&lang=js"
export * from "./rebateSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945ca978",
  null
  
)

export default component.exports